<template>
  <common-filter-form :filter="filterForm" :fields="allFields" :default-common-fields="defaultCommonFields" :default-more-fields="defaultMoreFields" config-key="faultFilterConfig" @change="handleFieldChange" @search="handleSearch" @reset="handleReset">
    <template slot="field" slot-scope="{ field, form, reset, labelCol, wrapperCol }">
      <fault-filter-form-item
        :form="form"
        :field="field"
        :options="{
          faultLevels: faultLevels,
          faultRecapStatus: faultRecapStatus,
          domainData: domainData,
          tagData: tagData,
          projects: projects
        }"
        :reset="reset"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        @change="handleFieldChange"
      />
    </template>
  </common-filter-form>
</template>

<script>
import { projectList } from '@/api/project/project';
import { tagList } from '@/api/system/tag';
import { domainList } from '@/api/system/domain';
import { faultLevels, faultRecapStatus } from '@/utils/dictionary';

import CommonFilterForm from '@/components/CommonFilterForm';
import FaultFilterFormItem from '@/pages/event/components/FaultFilterFormItem';

export default {
  name: 'FaultFilterForm',
  components: {
    CommonFilterForm,
    FaultFilterFormItem
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterForm: { ...this.value },
      faultLevels,
      faultRecapStatus,
      domainData: [],
      tagData: [],
      projects: [],
      // 所有可用的筛选项配置
      allFields: [
        { key: 'title', label: '标题', span: 6 },
        { key: 'domains', label: '业务域', span: 6 },
        { key: 'level', label: '等级', span: 6 },
        { key: 'tags', label: '标签', span: 6 },
        { key: 'projects', label: '项目', span: 6 },
        { key: 'dateRange', label: '时间筛选', span: 12, labelSpan: 3, wrapperSpan: 21 },
        { key: 'recap_status', label: '复盘状态', span: 6 }
      ],
      // 默认常用筛选字段
      defaultCommonFields: ['title', 'domains', 'level'],
      // 默认更多筛选字段
      defaultMoreFields: ['tags', 'projects', 'dateRange', 'recap_status']
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.filterForm = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getProjectList();
    this.getTagList();
    this.getDomainList();
  },
  methods: {
    handleFieldChange({ key, value }) {
      this.$set(this.filterForm, key, value);
      this.handleSearch();
    },

    handleSearch() {
      this.$emit('change', this.filterForm);
      this.$emit('update:value', this.filterForm);
    },

    handleReset() {
      // 定义默认的筛选表单值
      const defaultForm = {
        time_field: 'reported_time',
        begin_time: null,
        end_time: null,
        page_size: 10,
        page_number: 1
      };
      // 更新表单数据
      this.filterForm = { ...defaultForm };
      this.$emit('reset', defaultForm);
    },

    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },

    // 获取标签列表
    getTagList() {
      tagList({ group_code: 'fault' }).then(res => {
        this.tagData = res.data.items;
      });
    },

    // 获取业务域列表
    getDomainList() {
      domainList({}).then(res => {
        this.domainData = res.data.items;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fault-filter-form {
  .filter-actions {
    display: flex;
    text-align: right;
    margin-left: auto;
    align-items: flex-start;
    justify-content: flex-end;
  }

  :deep(.ant-form-item) {
    margin-bottom: 0px;

    .ant-form-item-label {
      text-align: right;
      color: #495057;
      padding-right: 8px;
    }
  }

  :deep(.filter-popover) {
    .ant-popover-inner-content {
      padding: 0;
    }
  }

  .filter-popover-content {
    width: 520px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 12px;

    .filter-sections {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .filter-section {
        h3 {
          margin-bottom: 4px;
          color: #495057;
          font-size: 13px;
          font-weight: 500;
          line-height: 1.2;
        }

        .field-list {
          .field-item {
            display: flex;
            align-items: center;
            cursor: move;

            .drag-handle {
              padding: 2px;
              cursor: move;
              opacity: 0.4;
              display: flex;
              align-items: center;
              transition: all 0.2s ease;

              &:hover {
                opacity: 0.7;
              }
            }

            :deep(.ant-form-item) {
              flex: 1;
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
